module.exports = __webpack_public_path__ + "static/media/blog-list-background.2250e7ce.png";